/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Pool_Country_PoolsInputs */

const bn_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কান্ট্রি পুল`)
};

const de_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landpools`)
};

const el_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Pools`)
};

const en_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Pools`)
};

const es_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piscinas campestres`)
};

const fr_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pools de pays`)
};

const hi_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देशी ताल`)
};

const hu_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéki medencék`)
};

const id_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolam Pedesaan`)
};

const it_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piscine di campagna`)
};

const ja_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カントリープール`)
};

const ko_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컨트리 풀`)
};

const nl_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landelijke zwembaden`)
};

const pl_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseny wiejskie`)
};

const pt_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piscinas rurais`)
};

const ru_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загородные бассейны`)
};

const sv_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Pooler`)
};

const tr_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke Havuzları`)
};

const uk_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дачні басейни`)
};

const vi_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ bơi đồng quê`)
};

const zh_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乡村泳池`)
};

const zh_hant_game_pool_country_pools = /** @type {(inputs: Game_Pool_Country_PoolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鄉村泳池`)
};

/**
* | output |
* | --- |
* | "Country Pools" |
*
* @param {Game_Pool_Country_PoolsInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_pool_country_pools = /** @type {((inputs?: Game_Pool_Country_PoolsInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Pool_Country_PoolsInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_pool_country_pools(inputs)
	if (locale === "de") return de_game_pool_country_pools(inputs)
	if (locale === "el") return el_game_pool_country_pools(inputs)
	if (locale === "en") return en_game_pool_country_pools(inputs)
	if (locale === "es") return es_game_pool_country_pools(inputs)
	if (locale === "fr") return fr_game_pool_country_pools(inputs)
	if (locale === "hi") return hi_game_pool_country_pools(inputs)
	if (locale === "hu") return hu_game_pool_country_pools(inputs)
	if (locale === "id") return id_game_pool_country_pools(inputs)
	if (locale === "it") return it_game_pool_country_pools(inputs)
	if (locale === "ja") return ja_game_pool_country_pools(inputs)
	if (locale === "ko") return ko_game_pool_country_pools(inputs)
	if (locale === "nl") return nl_game_pool_country_pools(inputs)
	if (locale === "pl") return pl_game_pool_country_pools(inputs)
	if (locale === "pt") return pt_game_pool_country_pools(inputs)
	if (locale === "ru") return ru_game_pool_country_pools(inputs)
	if (locale === "sv") return sv_game_pool_country_pools(inputs)
	if (locale === "tr") return tr_game_pool_country_pools(inputs)
	if (locale === "uk") return uk_game_pool_country_pools(inputs)
	if (locale === "vi") return vi_game_pool_country_pools(inputs)
	if (locale === "zh") return zh_game_pool_country_pools(inputs)
	return zh_hant_game_pool_country_pools(inputs)
});